import {
    Button,
    Grid,
    TextField,
    FormControl,
    Checkbox,
    FormControlLabel,
    Autocomplete,
    Box,
    Typography,
    MenuItem,
    Select,
    InputLabel,
} from "@mui/material";
import { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LoadingOverlay from "../mui/LoadingOverlay";
import { selectnodess } from "../redux/nodesSlice";
import DeleteIcon from "@mui/icons-material/Delete";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import AddAdditionalFields from "./AddAdditionalField";
import Autogooglecomplete from "./Autogooglecomplete";
import { selectgroups } from "../redux/businessSlice";
import WarnignModal from "./WarnignModal"
import { useCreateBranchMutation } from "../redux/organizationApi";

export function AddBranches() {
    const navigate = useNavigate();
    const allorganization = useSelector(selectnodess) || [];
    const [parentOptions, setParentOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const groups = useSelector(selectgroups);
    const [createBranch] = useCreateBranchMutation();


    const initialNode = {
        parentId: "",
        Branches: [
            {
                companyName: "",
                Manager: "",
                Address: "",
                Remarks: "",
                BusinessGroup: "",
                branch: false,
                additionalFields: [],
                location: { name: "", address: "", lat: "", lng: "", countryName: "" }
            },
        ],
    };

    const [nodeData, setNodeData] = useState(initialNode);
    const [errors, setErrors] = useState({
        parentId: "",
        Branches: [{ companyName: "", additionalFields: [], location: { name: "", address: "", lat: "", lng: "", countryName: "" } }],
    });

    useEffect(() => {
        const mainBranches = Array.isArray(allorganization) && allorganization?.filter(
            (item) => item.isBranch === false && item.isOperatingCompany === true
        );
        const parents = mainBranches?.map((org) => {
            return {
                label: org.data.label,
                value: org.id.toString(),
                parentid: org.id,
            };
        });
        setParentOptions(parents);
    }, [allorganization]);

    const handleBranchChange = (index, field, value) => {
        const updatedBranches = [...nodeData.Branches];
        updatedBranches[index] = {
            ...updatedBranches[index],
            [field]: value,
        };
        setNodeData((prevData) => ({ ...prevData, Branches: updatedBranches }));
    };
    const handleAddBranch = () => {
        setNodeData((prev) => ({
            ...prev,
            Branches: [
                ...prev.Branches,
                {
                    companyName: "",
                    Manager: "",
                    Address: "",
                    BusinessGroup: "",
                    Remarks: "",
                    branch: false,
                    additionalFields: [],
                    location: { name: "", address: "", lat: "", lng: "", countryName: "" }
                },
            ],
        }));
    };
    const deleteBranch = (index) => {
        setNodeData((prev) => ({
            ...prev,
            Branches: prev.Branches?.filter((_, i) => i !== index),
        }));
    };
    const validateInput = () => {
        const errorObject = { parentId: "", Branches: [] };

        nodeData.Branches?.forEach((branch, index) => {
            const branchErrors = {};

            // Validate companyName
            if (!branch.companyName || branch.companyName.trim() === "") {
                branchErrors.companyName = "Branch Name is required";
            }

            // Validate BusinessGroup
            if (!branch.BusinessGroup || branch.BusinessGroup.trim() === "") {
                branchErrors.BusinessGroup = "Select Business Group";
            }

            // Validate additionalFields
            if (Array.isArray(branch.additionalFields)) {
                branch.additionalFields?.forEach((field, fieldIndex) => {
                    const fieldErrors = {};

                    // Validate fieldName in additionalFields
                    if (!field.fieldName || field.fieldName.trim() === "") {
                        fieldErrors.fieldName = "Field Name is required";
                    }

                    // Validate fieldValue in additionalFields
                    if (!field.fieldValue || field.fieldValue.trim() === "") {
                        fieldErrors.fieldValue = "Field Value is required";
                    }

                    // Add the field errors to the branch's additionalFields errors
                    if (Object.keys(fieldErrors).length > 0) {
                        if (!branchErrors.additionalFields) {
                            branchErrors.additionalFields = [];
                        }
                        branchErrors.additionalFields[fieldIndex] = fieldErrors;
                    }
                });
            }

            // Save branch errors
            errorObject.Branches[index] = branchErrors;
        });

        // Validate parentId
        if (!nodeData.parentId || nodeData.parentId.trim() === "") {
            errorObject.parentId = "Select parent Company";
        }

        setErrors(errorObject);

        // Check if the form is valid
        const isValid =
            !errorObject.parentId &&
            errorObject.Branches.every(
                (branchError) =>
                    Object.keys(branchError).length === 0 &&
                    (!branchError.additionalFields ||
                        branchError.additionalFields.every(
                            (fieldError) => Object.keys(fieldError).length === 0
                        ))
            );

        return isValid;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!validateInput()) {
            return;
        }
        try {
            setLoading(true);
            await createBranch({
                ...nodeData,
                isBranch: true,
            }).unwrap();
            toast.success(`Branches added successfully!`);
            setNodeData(initialNode);
            navigate("/admin/Organisational-Chart");
        } catch (error) {
            console.error("Error adding Branches:", error);
            toast.error(error?.data?.message || error?.error || "Failed to add branches");
        } finally {
            setLoading(false);
        }
    };
    const handleCheckboxChange = (index) => {
        const updatedBranches = [...nodeData.Branches];
        updatedBranches[index].branch = !updatedBranches[index].branch; // Toggle checkbox state
        setNodeData((prevData) => ({ ...prevData, Branches: updatedBranches }));
    };
    const handleRemarksChange = (value, index) => {
        const updatedBranches = [...nodeData.Branches];
        updatedBranches[index] = {
            ...updatedBranches[index],
            ["Remarks"]: value,
        };
        setNodeData((prevData) => ({ ...prevData, Branches: updatedBranches }));
    };


    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    // Additional Fields  COde
    const handleBranchDataUpdate = (updatedData, branchIndex) => {

        setNodeData(prevData => ({
            ...prevData,
            Branches: prevData.Branches?.map((branch, i) =>
                i === branchIndex
                    ? { ...branch, additionalFields: updatedData?.additionalFields }
                    : branch
            )
        }));
    };

    // Create a custom handler that intercepts location updates and routes them to the correct branch
    const createBranchLocationHandler = (branchIndex) => {
        return (updater) => {
            setNodeData((prevData) => {
                const updatedData = typeof updater === 'function' ? updater(prevData) : updater;

                // If the update includes a location property, route it to the specific branch
                if (updatedData && updatedData.location) {
                    const { location, ...restData } = updatedData;
                    return {
                        ...prevData,
                        ...restData,
                        Branches: prevData.Branches?.map((branch, i) =>
                            i === branchIndex
                                ? { ...branch, location: location }
                                : branch
                        )
                    };
                }
                // If no location in update, apply the update normally
                return typeof updater === 'function' ? updatedData : { ...prevData, ...updatedData };
            });
        };
    };


    return (
        <>
            {open && (
                <WarnignModal
                    handleClose={handleClose}
                    open={open}
                    from="Branches"
                />
            )}
            <Box sx={{ padding: "20px", maxWidth: "900px", margin: "auto" }}>
                <Typography variant="h4" align="center" gutterBottom>
                    Add Branches
                </Typography>
                <Box
                    component="form"
                    onSubmit={handleSubmit}
                    sx={{ backgroundColor: "#f5f5f5", p: 3, borderRadius: 2 }}
                >
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={6}>
                            <FormControl fullWidth>
                                <Autocomplete
                                    options={parentOptions}
                                    getOptionLabel={(option) => option.label || ""}
                                    value={
                                        parentOptions?.find(
                                            (option) => option.parentid === nodeData.parentId
                                        ) || null
                                    }
                                    onChange={(event, newValue) => {
                                        if (newValue) {
                                            setNodeData((prev) => ({
                                                ...prev,
                                                parentId: newValue.parentid,
                                            }));
                                        }
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Operating Company"
                                            error={Boolean(errors.parentId)}
                                            helperText={errors.parentId}
                                            fullWidth
                                            size="small"
                                        />
                                    )}
                                />
                            </FormControl>
                        </Grid>
                        {nodeData.Branches?.map((branch, index) => (
                            <Grid item xs={12} key={index}>
                                <Box
                                    sx={{
                                        backgroundColor: "#fff",
                                        padding: 2,
                                        borderRadius: 1,
                                        boxShadow: 1,
                                    }}
                                >
                                    <Typography variant="subtitle1" gutterBottom>
                                        Branch {index + 1}
                                    </Typography>
                                    <Grid container spacing={2}>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label="Branch Name"
                                                variant="outlined"
                                                value={branch.companyName}
                                                onChange={(e) =>
                                                    handleBranchChange(
                                                        index,
                                                        "companyName",
                                                        e.target.value
                                                    )
                                                }
                                                fullWidth
                                                error={Boolean(errors.Branches[index]?.companyName)}
                                                helperText={errors.Branches[index]?.companyName}
                                                size="small"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <Autogooglecomplete
                                                setNodeData={createBranchLocationHandler(index)}
                                                errors={errors}
                                                nodeData={{ location: branch?.location || {} }}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControl
                                                fullWidth
                                                size="small"
                                                variant="outlined"
                                                error={Boolean(errors.Branches[index]?.BusinessGroup)}
                                            >
                                                <InputLabel>Business Groups</InputLabel>
                                                <Select
                                                    name="BusinessGroup"
                                                    value={nodeData.BusinessGroup}
                                                    onChange={(e) =>
                                                        handleBranchChange(index, "BusinessGroup", e.target.value)
                                                    }
                                                    label="Business Groups"
                                                >
                                                    {groups?.map((item, index) => {
                                                        return (
                                                            <MenuItem key={index} value={item._id}>
                                                                {item?.businessNature?.charAt(0)?.toUpperCase() + item?.businessNature?.slice(1)}
                                                            </MenuItem>
                                                        );
                                                    })}
                                                </Select>
                                                {errors.Branches[index]?.BusinessGroup && (
                                                    <Typography color="error" variant="caption">
                                                        {errors.Branches[index].BusinessGroup}
                                                    </Typography>
                                                )}
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label="Office / Branch Manager"
                                                variant="outlined"
                                                value={branch.Manager}
                                                onChange={(e) =>
                                                    handleBranchChange(index, "Manager", e.target.value)
                                                }
                                                fullWidth
                                                size="small"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                label="Registered Address"
                                                variant="outlined"
                                                value={branch.Address}
                                                onChange={(e) =>
                                                    handleBranchChange(index, "Address", e.target.value)
                                                }
                                                fullWidth
                                                size="small"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={branch.branch}
                                                        onChange={() => handleCheckboxChange(index)}
                                                        color="primary"
                                                        name="Incorporate In Progress"
                                                    />
                                                }
                                                label="Status: Incorporate In Progress/To be Liquidated"
                                            />
                                        </Grid>
                                        <Grid sx={{ marginTop: "10px", marginBottom: "10px" }} item xs={12}>
                                            <AddAdditionalFields nodeData={{ additionalFields: branch?.additionalFields || [] }} setNodeData={(data) => {
                                                // console.log(data, "data for branches");
                                                handleBranchDataUpdate(data, index);
                                            }} errors={{ additionalFields: errors?.Branches[index]?.additionalFields || [] }} />
                                        </Grid>
                                        {index !== 0 && (
                                            <Grid item xs={6} sx={{ textAlign: "right" }}>
                                                <DeleteIcon
                                                    style={{
                                                        fontSize: "30px",
                                                        color: "#1976d2",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => deleteBranch(index)}
                                                />
                                            </Grid>
                                        )}
                                        <Grid item xs={12} container sx={{ mb: 5 }}>
                                            <ReactQuill
                                                value={branch?.Remarks || ""} // Bind value to state, ensure it's a string
                                                onChange={(value) => {
                                                    handleRemarksChange(value, index);
                                                }}
                                                modules={{
                                                    toolbar: [
                                                        // Headers and font size
                                                        [
                                                            { header: "1" },
                                                            { header: "2" },
                                                            { font: [] },
                                                            { size: [] },
                                                        ],
                                                        // Text formatting
                                                        [
                                                            "bold",
                                                            "italic",
                                                            "underline",
                                                            "strike",
                                                            "blockquote",
                                                        ],
                                                        // Lists and alignment
                                                        [
                                                            { list: "ordered" },
                                                            { list: "bullet" },
                                                            { align: [] },
                                                        ],
                                                        // Color and background color
                                                        [{ color: [] }, { background: [] }],
                                                        // Links and clear formatting
                                                        ["link"],
                                                        ["clean"], // Clear formatting
                                                    ],
                                                }}
                                                placeholder="Enter remarks here..."
                                                style={{
                                                    width: "100%", // Takes full width of the container
                                                    height: "200px", // Custom height
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Grid>
                        ))}

                        <Grid item xs={12} className="d-flex justify-content-end">
                            <Button
                                variant="contained"
                                color="primary"
                                size="medium"
                                endIcon={<AddIcon />}
                                onClick={handleAddBranch}
                            >
                                Add Branch
                            </Button>
                        </Grid>

                        <Grid item xs={12}>
                            <Button
                                onClick={handleSubmit}
                                variant="contained"
                                color="primary"
                                fullWidth
                            >
                                Submit
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                sx={{ mr: 1, }}
                                onClick={handleClickOpen}
                                variant="outlined"
                                fullWidth
                            // disabled={sharedata !== 0}
                            >
                                Cancel
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
            {loading && <LoadingOverlay open={loading} />}


        </>
    );
}
